let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("89k3K")).then(() => parcelRequire('Co4xy'));